import React, { Component } from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";

import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import SpeedOutlinedIcon from "@mui/icons-material/SpeedOutlined";
import OilBarrelOutlinedIcon from "@mui/icons-material/OilBarrelOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";


import TrackChangesOutlinedIcon from "@mui/icons-material/TrackChangesOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

import DashboardHeader from "./DashboardHeader";
import SummaryCard from "../../components/dashlibs/SummaryCard";
import SectionCard from "../../components/dashlibs/SectionCard";
import StatusBadge from "../../components/dashlibs/StatusBadge";
import AlertList from "../../components/dashlibs/AlertList";
import { MockBarChart, MockTrendChart } from "../../components/dashlibs/MockChart";
import { DashboardPageProps } from "./dashboard.types";

import type { ChartTone } from "../../components/charts";
import { DonutChart, AreaTrendChart, BarChart, TreemapChart, LineTrendChart, BulletChart, RadarChart } from "../../components/charts";

// const depotPerformance = [
//   { label: "Bingo", value: 74, color: "#116B43" },
//   { label: "Bobo", value: 61, color: "#163A5F" },
//   { label: "Ouaga Dépôt", value: 58, color: "#2471A3" },
//   { label: "Site secondaire", value: 42, color: "#D68910" },
// ];

// const productFlow = [
//   { label: "Super", value: 69, color: "#116B43" },
//   { label: "Gasoil", value: 64, color: "#163A5F" },
//   { label: "Gaz", value: 52, color: "#2471A3" },
//   { label: "Jet A1", value: 39, color: "#D68910" },
// ];

// const logisticsEfficiency = [
//   { label: "Temps rotation flotte", value: 58, color: "#116B43" },
//   { label: "Disponibilité chargement", value: 71, color: "#163A5F" },
//   { label: "Utilisation capacité", value: 63, color: "#2471A3" },
//   { label: "Retards livraison", value: 34, color: "#C0392B" },
// ];

// const opsTrend = [44, 46, 49, 51, 56, 61, 63, 67, 69, 71, 73, 76];

// const operationsAlerts = [
//   {
//     title: "Pression sur le dépôt de Bingo",
//     description: "Le rythme d’activité et la sollicitation des capacités nécessitent une surveillance rapprochée.",
//     tone: "warning" as const,
//   },
//   {
//     title: "Retards logistiques sur certains flux",
//     description: "Des retards de rotation ou de traitement affectent l’efficacité opérationnelle.",
//     tone: "danger" as const,
//   },
//   {
//     title: "Bonne tenue de la disponibilité de chargement",
//     description: "Les installations principales maintiennent un niveau de disponibilité satisfaisant.",
//     tone: "success" as const,
//   },
// ];

// const locationRisk = [
//   { label: "Bingo", value: 71, color: "#C0392B" },
//   { label: "Bobo", value: 49, color: "#D68910" },
//   { label: "Siège", value: 22, color: "#2471A3" },
//   { label: "Site secondaire", value: 57, color: "#A93226" },
// ];

export default class OperationsDashboard extends Component<DashboardPageProps,any> {

  render(){
  const {userData,dashData,sharedFilters,filterOptions,onFilterChange,onRefresh} = this.props;
  const {meta,sections={},summaryCards=[]} = dashData || {};

  const {operationsTrend={},operationalAlerts={},depotPerformance={},productFlow={}} = sections;
  const {logisticsEfficiency={},operationalNarrative={},locationRisk={},} = sections;

  const iconMap: any = {
    place: <PlaceOutlinedIcon />,
    barrel: <OilBarrelOutlinedIcon />,
    inventory: <Inventory2OutlinedIcon />,
    shipping: <LocalShippingOutlinedIcon />,
    speed: <SpeedOutlinedIcon />,
    warning: <WarningAmberOutlinedIcon />,
  }
  
    
  return (
    <Box sx={{ p: { xs: 2, md: 3 }, display: "grid", gap: 2.5 }}>
      <DashboardHeader
        title="Dashboard Intelligence Opérationnelle"
        subtitle="Vue consolidée des dépôts, des produits, des flux logistiques et de l’efficacité opérationnelle."
        userData={userData}
        sharedFilters={sharedFilters}
        filterOptions={filterOptions}
        onFilterChange={onFilterChange}
        onRefresh={onRefresh}
      />

      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 2 }}>
        {(summaryCards || []).map((card: any) => (
        <SummaryCard
          key={card.code}
          title={card.label}
          value={card.valueFormatted}
          subtitle={card.subtitle}
          delta={card.deltaFormatted}
          tone={card.tone}
          icon={iconMap[card.icon] || <AccountBalanceWalletOutlinedIcon />}
        />
        ))}
      </Box>
      
      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", md: "1.35fr 1fr" } }}>
        <SectionCard
          title={operationsTrend.title || ""}
          subtitle={operationsTrend.subtitle || ""}
        >
          <LineTrendChart data={(operationsTrend.data || [])} />
        </SectionCard>

        <SectionCard
          title={operationalAlerts.title || ""}
          subtitle={operationalAlerts.subtitle || ""}
        >
          <AlertList items={operationalAlerts.data || []} />
        </SectionCard>
      </Box>

      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" } }}>
        <SectionCard
          title={depotPerformance.title || ""}
          subtitle={depotPerformance.subtitle || ""}
        >
          <BulletChart data={(depotPerformance.data || [])} />
        </SectionCard>

        <SectionCard
          title={productFlow.title || ""}
          subtitle={productFlow.subtitle || ""}
        >
          <DonutChart data={(productFlow.data || [])} />
        </SectionCard>
      </Box>

      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" } }}>
        <SectionCard
          title={logisticsEfficiency.title || ""}
          subtitle={logisticsEfficiency.subtitle || ""}
        >
          <RadarChart data={logisticsEfficiency.data || []} />
        </SectionCard>

        <SectionCard
          title={locationRisk.title || ""}
          subtitle={locationRisk.subtitle || ""}
        >
          <TreemapChart data={locationRisk.data || []} />
        </SectionCard>
      </Box>

      {/* <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "1fr" }} >
        <SectionCard
          title={operationalNarrative.title || ""}
          subtitle={operationalNarrative.subtitle || ""}
        >
          <AlertList items={(operationalNarrative.data || []).map((x: any) => ({
                        label: x.label,
                        value: Number(x.value || 0),
                        color:
                          x.tone === "danger"
                            ? "#A93226"
                            : x.tone === "warning"
                            ? "#D68910"
                            : "#116B43",
                      }))} />
        </SectionCard>
      </Box> */}

      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "1fr" }} >
        <SectionCard
          title={operationalNarrative.title || "Lecture opérationnelle"}
          subtitle={operationalNarrative.subtitle || "Messages clés de pilotage pour l’exploitation."}
        >
          {/* <AlertList items={(operationalNarrative.data || [])} /> */}
          <Stack spacing={1.25}>
            {/* {(operationalNarrative.data || []).map(([title, description]:any,idx:number) => ( */}
            {(operationalNarrative.data || []).map((rec:any,idx:number) => (
              <Box
                key={idx}
                sx={{
                  p: 1.5,
                  borderRadius: "10px",
                  border: "1px solid #E2E8EE",
                  bgcolor: "#FFFFFF",
                }}
              >
                <Typography sx={{ fontSize: 13, fontWeight: 800, color: "#17324D" }}>
                  {rec.title}
                </Typography>
                <Typography sx={{ fontSize: 13, color: "#66788A", mt: 0.5, lineHeight: 1.65 }}>
                  {rec.description}
                </Typography>
              </Box>
            ))}
          </Stack>
        </SectionCard>
      </Box>

{/* 
      <Box
        sx={{
          display: "grid",
          gap: 2,
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            lg: "repeat(6, 1fr)",
          },
        }}
      >
        <SummaryCard
          title="Dépôts suivis"
          value="4"
          subtitle="Sites opérationnels"
          delta="Actifs"
          tone="info"
          icon={<PlaceOutlinedIcon />}
        />
        <SummaryCard
          title="Produits clés"
          value="4"
          subtitle="Familles surveillées"
          delta="Stratégiques"
          tone="default"
          icon={<OilBarrelOutlinedIcon />}
        />
        <SummaryCard
          title="Performance dépôts"
          value="64%"
          subtitle="Score moyen"
          delta="+3 pts"
          tone="success"
          icon={<Inventory2OutlinedIcon />}
        />
        <SummaryCard
          title="Efficacité logistique"
          value="61%"
          subtitle="Indice global"
          delta="Amélioration"
          tone="info"
          icon={<LocalShippingOutlinedIcon />}
        />
        <SummaryCard
          title="Capacité utilisée"
          value="73%"
          subtitle="Moyenne observée"
          delta="Sous tension"
          tone="warning"
          icon={<SpeedOutlinedIcon />}
        />
        <SummaryCard
          title="Alertes terrain"
          value="3"
          subtitle="À traiter"
          delta="1 critique"
          tone="danger"
          icon={<WarningAmberOutlinedIcon />}
        />
      </Box>

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 8 }}>
          <SectionCard
            title="Tendance de performance opérationnelle"
            subtitle="Évolution consolidée des indicateurs logistiques et de disponibilité."
            action={<StatusBadge label="Ops trend" tone="info" />}
          >
            <MockTrendChart points={opsTrend} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Alertes opérationnelles"
            subtitle="Risques ou points d’attention dans les opérations."
          >
            <AlertList items={operationsAlerts} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Performance par dépôt"
            subtitle="Lecture comparée de la performance opérationnelle par site."
          >
            <MockBarChart data={depotPerformance} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Flux par produit"
            subtitle="Vue synthétique des familles produit les plus dynamiques."
          >
            <MockBarChart data={productFlow} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Efficacité logistique"
            subtitle="Indicateurs simplifiés sur le fonctionnement des flux."
          >
            <MockBarChart data={logisticsEfficiency} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <SectionCard
            title="Lecture opérationnelle"
            subtitle="Messages clés de pilotage pour l’exploitation."
          >
            <Stack spacing={1.25}>
              {[
                ["Bingo reste le site le plus sollicité", "Le dépôt concentre une forte intensité d’activité et mérite un pilotage renforcé."],
                ["Les flux produits restent inégalement performants", "Certaines familles comme le Jet A1 présentent des profils d’activité plus faibles."],
                ["La logistique progresse mais reste exposée", "L’efficacité des flux s’améliore mais certains retards et contraintes persistent."],
              ].map(([title, desc]) => (
                <Box
                  key={title}
                  sx={{
                    p: 1.5,
                    borderRadius: "10px",
                    border: "1px solid #E2E8EE",
                    bgcolor: "#FFFFFF",
                  }}
                >
                  <Typography sx={{ fontSize: 13, fontWeight: 800, color: "#17324D" }}>
                    {title}
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "#66788A", mt: 0.5, lineHeight: 1.65 }}>
                    {desc}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <SectionCard
            title="Exposition géographique"
            subtitle="Lecture simplifiée du niveau de risque ou de tension par site."
            action={<StatusBadge label="Location risk" tone="warning" />}
          >
            <MockBarChart data={locationRisk} />
          </SectionCard>
        </Grid>
      </Grid> */}
    </Box>
  );
}
}
